<style lang="less">
.login{
	.top-logo{line-height: 70px; background: #fff;}
	.top-logo-wrap{position:relative;width:1200px;margin:0 auto;}
	.top-logo img{margin-left:50px;}
	.banner-about{position:relative; overflow: hidden; width: 100%; height: 420px; background:#eff4f8; background-size: cover;}

	.footer{width:100%;height:265px;background:#232426;}
	.footer-inner{overflow:hidden; width:1015px; height:100%; margin:0 auto;}
	.footer-inner>div{padding-top:58px;}
	.footer-inner .contact-us{float:left; width:734px;}
	.footer-inner .qr-code{float:left; width:281px}
	.footer-inner .contact-us .title{padding-bottom:25px; font-size:18px; color:#aaaaaa;}
	.footer-inner .contact-us .we-chats{padding-bottom:30px; font-size:12px; color:#999;}
	.footer-inner .contact-us .we-chats .ml1{margin-left:43px}
	.footer-inner .contact-us .we-chats .ml2{margin-left:20px}
	.footer-inner .contact-us .company,
	.footer-inner .contact-us .icp-info{font-size: 12px; color: #999;}
	.footer-inner .contact-us .line{width:600px; margin-bottom:25px; border-bottom:1px solid rgba(255,255,255,0.1);}
	.footer-inner .qr-code{font-size:0;}
	.footer-inner .qr-code>div{display:inline-block; width:125px; text-align:center}
	.footer-inner .qr-code span{display: block; font-size:12px; line-height:50px; color:#999;}
	.footer-inner .qr-code div:nth-child(1){margin-right:30px}
	.footer-inner .qr-code img{width:125px; height:125px;}

    .p-main{margin:48px 200px 0  200px}
    .p-title{ }
    .p-content{padding-top:10px}
}
</style>

<template lang="html">
    <div class="login">
        <div class="top-logo">
			<div class="top-logo-wrap">
				<img src="../login/images/logo.png" alt="">
				<img src="../login/images/slogan.png" alt="">
			</div>
		</div>
        <div class="banner-about">

        <div class="p-main">
            <h4 class="p-title">公司简介</h4>
            <p class="p-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;北京班小二科技有限公司，成立于2018年6月，创始人之前任职于国内知名教育上市公司，从事于互联网教育领域的软件开发行业，主持过多个移动端应用的项目开发的，对该行业有相关丰富的产品经验； 当前公司已经得到 “蓝象资本” 以及 “涌铧投资” 作为合作方的资本参与，“蓝象资本”-未来工场团队有着丰富的投资和管理经验，在教育行业深耕多年，积累起了广泛的人脉和深厚的行业资源。公司具有技术强大的研发团队成员以及先进成熟的产品开发方案，拥有产品、UI、前端开发、后台开发、测试、数据架构、网络安全等全线技术开发人员，技术团队采用行业成熟领先的技术和协同工具进行产品开发；</p>
            <p class="p-content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;公司专注于教育互动类的微信小程序开发，重点产品是“班小二”，是是一款为微信班级群定制的，解决班级群内通知被刷屏、接龙混乱、习惯养成打卡、照片共建共享、班费收缴等问题的小程序。班小二与微信群的完美结合，即保留了微信群沟通的便利、及时性，又很好的解决了微信群消息刷屏、无法统计分类、无法永久留存等痛点，真正成为家校协同、共育的神器。 </p>
            <p></p>
        </div>

        </div>
        <div class="footer">
            <div class="footer-inner">
                <div class="contact-us">
                    <div class="title">联系我们</div>
                    <div class="we-chats">
                        <div>联系号码<span class="ml1">15913338403</span></div>
                        <div>客服微信<span class="ml1">banxiaoer01</span></div>
                        <div>渠道合作微信<span class="ml2">lambs_</span></div>
                    </div>
                    <div class="line"></div>
                    <div class="company">2018 © www.banxe.cn  北京班小二科技有限公司</div>
                    <div class="icp-info">{{isBanxe?'京ICP备18046531号-1':'粤ICP备18028843号-2'}}
                        <div style="width:300px;margin:0 auto; padding:20px 0;">
                            <a target="_blank" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=44200002443428"
                            style="display:inline-block;text-decoration:none;height:20px;line-height:20px;">
                            <img src="https://bxe-1255477954.cos.ap-beijing.myqcloud.com/fronts/gh.png" style="float:left;"/>
                                <p style="float:left;height:20px;line-height:20px;margin: 0px 0px 0px 5px; color:#939393;">粤公网安备 44200002443428号</p>
                            </a>
                        </div>
                    </div>
                </div>
                <div class="qr-code">
                    <div>
                        <img src="../login/images/bxecode--fwh.png" alt="">
                        <span>"班小二" 服务号</span>
                    </div>
                    <div>
                        <img src="../login/images/bxecode-xcx.png" alt="">
                        <span>"班小二" 小程序</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>


export default {
	name : 'about',
	components : {

	}
}
</script>



// WEBPACK FOOTER //
// src/components/about/about.vue